import { Component, OnInit } from '@angular/core';
import { UtilitesService } from 'app/base-module/base-service/utilites.service';

@Component({
  selector: 'app-sso-init',
  templateUrl: './sso-init.component.html',
  styleUrls: ['./sso-init.component.scss']
})
export class SsoInitComponent implements OnInit {

  constructor(private utilitesService: UtilitesService) { }

  ngOnInit(): void {
    let backendUrl = this.utilitesService.urlPrefix; 

    if (backendUrl) {
        backendUrl = backendUrl.replace('api/v1/', '').replace('api/', '');
        
        if (!backendUrl.endsWith('/')) {
            backendUrl += '/';
        }
    } else {
        backendUrl = '/'; 
    }

    
    const timestamp = new Date().getTime();

    const targetUrl = `${backendUrl}auth/microsoft/redirect?v=${timestamp}`;

    window.location.href = targetUrl;
  }
}